class IntersectionObserverScroll {
  constructor(targetSelector, activeClass) {
    this.targetSelector = targetSelector;
    this.activeClass = activeClass;
    this.inviewElements = new Map();
    this._intersectionObserver();
  }

  _intersectionObserver() {
    // Intersection Observerの設定
    const observerOptions = {
      root: null, // ルートをビューポートとする
      threshold: 0.5, // ターゲットが50%以上可視であればコールバックを呼び出す
    };

    // コールバック関数
    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.inviewElements.has(entry.target)) {
          // ターゲットが画面内に入り、まだ処理されていない場合
          entry.target.classList.add(this.activeClass);
          this.inviewElements.set(entry.target, true); // 処理済みフラグをセット
        }
      });
    };

    // 全ての .js-inview 要素を監視対象に設定
    document.querySelectorAll(this.targetSelector).forEach((element) => {
      const observer = new IntersectionObserver(
        handleIntersection,
        observerOptions,
      );
      observer.observe(element);
    });
  }
}

export default IntersectionObserverScroll;
